const metric = (value) => {
    const number = Number(value ?? 0);
    return Number.isFinite(number) ? number : 0;
};

export const buildConsultationAdjustment = (metrics = {}) => {
    const inventory = metrics.inventory || {};
    const consultation = metrics.consultation || {};
    const item = (key) => {
        const before = metric(inventory[key]);
        const after = metric(consultation[key]);
        return { before, after, delta: after - before };
    };
    return {
        cashFlow: item('monthly_cash_flow'),
        netAsset: item('net_asset_value')
    };
};
